<div class="page" [ngClass]="{'is-widget' : isWidget$ | async}">
  <div class="container container-lg no-container-widget">

    <app-breadcrumb></app-breadcrumb>

    <div class="wrapper-page wrapper-page--column" *ngIf="this.holidayDetails">
      <!-- Header -->
      <div class="page-header order-2 order-lg-1">
        <app-detail-header [holidayDetails]="holidayDetails" [bookingUrl]="this.bookingUrl">
        </app-detail-header>
      </div>

      <!-- Gallery -->
      <div class="page-gallery order-1 order-lg-2">
        <app-detail-gallery [holidayDetails]="holidayDetails">
        </app-detail-gallery>
      </div>

      <div class="detail-tabs__container order-3">
        <app-detail-content-accomodation-tabs
          [holidayDetails]="holidayDetails"
          [selectedSolution]="null"> <!-- //TODO -->
        </app-detail-content-accomodation-tabs>
      </div>

      <div class="detail-container wrapper-page order-4 mt-4">


        <!-- Solution Descriptions -->
        <div class="detail-container__tabs wrapper-page__content order-2 order-lg-1">
          <div class="detail-content__container">

            <!-- // WTG PRICE GRID -->
            <ng-container #priceGrid *ngIf="brand?.detailPageConfig?.showPriceGrid">
              <div class="detail-content mt-4 accomodation-tab__solutions" *ngIf="allSolutionsToShow.length > 0">
                <!--                <ng-container *ngIf="holidayDetails?.solutions?.length">-->

                <holiday-detail-generic-page-price-grid
                  [accomodationParentId]="this.accomodationParentId"
                  [inputMonthSolutions]="this.allSolutionsToShow"
                  [allAvailableDates]="this.allAvailableDates"
                  (newMonthSelectedEvent)="this.onSelectedMonthChange($event)"
                >
                </holiday-detail-generic-page-price-grid>
                <!--                </ng-container>-->

                <div class="detail-recap__row detail-recap__cta__wrapper mb-5 d-lg-none"
                     *ngIf="(isWidget$ | async)">
                  <a class="detail-recap__cta__button btn btn--brand-color-03" dynamicNavigation
                     [href]="bookingUrl">
                    Prosegui
                  </a>
                </div>
              </div>
              <div  class="detail-content mt-4 accomodation-tab__solutions" *ngIf="allSolutionsToShow.length < 1">
                <h5 class="detail-steps__title">Soluzioni disponibili</h5>
                <p class="warning-lables">Nessuna soluzione disponibile per le opzioni selezionate, prova con un altra formula!</p>
              </div>
            </ng-container>

            <div class="detail-content__section accomodation-tab__tags my-4" *ngIf="holidayDetails?.tags">
              <div class="detail-content__row">
                <app-detail-content-tags [tags]="holidayDetails?.tags"></app-detail-content-tags>
              </div>
            </div>
            <div class="detail-content__section mb-4" *ngIf="holidayDetails?.isPacketVisible">
              <detail-content-packet [packet]="holidayDetails.packet"></detail-content-packet>
            </div>
            <div *ngIf="holidayDetails?.texts" class="accomodation-tab__details my-4">
              <app-detail-content-description
                [texts]="holidayDetails?.texts"></app-detail-content-description>
            </div>

            <div class="detail-content__section accomodation-tab__map" *ngIf="holidayDetails?.accomodation">
              <div class="detail-content__row">
                <div class="detail-content__section detail-content__map">
                  <app-detail-content-map
                    [accomodation]="holidayDetails?.accomodation"></app-detail-content-map>
                </div>
              </div>
              <hr class="dashed-border">
            </div>

            <div class="detail-content__section detail-content__activities accomodation-tab__activities"
                 *ngIf="holidayDetails?.activities?.length">
              <app-detail-content-activities
                [activities]="holidayDetails?.activities"></app-detail-content-activities>
              <hr class="dashed-border">
            </div>

            <div class="detail-content__section detail-content__languages"
                 *ngIf="holidayDetails?.languages?.length">
              <app-detail-content-languages
                [languages]="holidayDetails?.languages"></app-detail-content-languages>
              <hr class="dashed-border">
            </div>

            <div class="detail-content__section detail-content__facilities accomodation-tab__facilities"
                 *ngIf="holidayDetails?.facilities?.length">
              <app-detail-content-facilities
                [facilities]="holidayDetails?.facilities"></app-detail-content-facilities>
              <hr class="dashed-border">
            </div>

            <div class="detail-content__section accomodation-tab__itinerary"
                 *ngIf="holidayDetails?.tour?.itinerary">
              <div class="detail-content__row">
                <div class="detail-content__section detail-content__map">
                  <app-detail-content-itinerary [itinerary]="holidayDetails?.tour?.itinerary">
                  </app-detail-content-itinerary>
                </div>
              </div>
              <hr class="dashed-border">
            </div>

            <div class="detail-content mt-4" *ngIf="holidayDetails?.accessories?.length">
              <div class="detail-content__section detail-content__info accomodation-tab__terms">
                <app-detail-content-terms
                  [accessories]="holidayDetails?.accessories"></app-detail-content-terms>
              </div>
              <hr class="dashed-border">
            </div>

            <!--  //  Scelta occupancy e data e lista solutions solo per GEO-->
            <ng-container *ngIf="!brand?.detailPageConfig?.showPriceGrid">

              <detail-occupancy></detail-occupancy>

              <hr>

              <holiday-detailgeneric-page-date [allAvailableDates]="this.allAvailableDates"></holiday-detailgeneric-page-date>

              <hr>

              <!-- Lista Soluzioni-->
              <section class="detail-content__section accomodation-tab__flights" id="solutionsList">
                <holiday-detail-generic-page-solutions
                  (livePricesLoadingComplete)="this.livePricesLoadingCompletedOnChildComponent()"
                  [detailSolutions]="this.allSolutionsToShow"
                  [formattedGuestsString]="this.formattedGuestsString"
                  [allAvailableDates]="this.allAvailableDates">
                </holiday-detail-generic-page-solutions>
              </section>

            </ng-container>

            <div class="wrapper-buttons detail-cta text-center" *ngIf="!isLanding"
                 [ngClass]="{'is-widget' : (isWidget$ | async)}">
              <a class="btn btn--brand-color-03 text-left" [class.disabled]="!this.bookingUrl"
                 dynamicNavigation [href]="bookingUrl"
                >
                <h5>Prosegui</h5>
                <span>verifica disponibilità e prezzo</span>
                <i class="g-icon-chevron-right-circle"></i>
              </a>
            </div>

          </div>
        </div>

        <div class="detail-container__aside wrapper-page__aside order-1 order-lg-2">
          <div class="detail-recap__container" [ngClass]="{'detail-recap__container--fixed' : fixedRecap }">
            <ng-container *ngIf="!this.selectedSolution">
              <holiday-detail-generic-page-recap
                [fallbackPrice]="this.fallbackPrice"
                [allSolutionForSelectedDate]="this.allSolutionsToShow"
                [formattedGuestsString]="this.formattedGuestsString"
                [destinationName]="this.destinationName"
                [allAvailableDates]="this.allAvailableDates">
              </holiday-detail-generic-page-recap>
            </ng-container>
            <ng-container *ngIf="this.selectedSolution">
              <app-detail-content-aside
                [holidayDetails]="this.holidayDetails"
                [selectedSolution]="this.selectedSolution"
                [bookingUrl]="this.bookingUrl"
                [formattedGuestsString]="this.formattedGuestsString"
                [destinationName]="this.destinationName"
                [isLanding]="this.isLanding"
              ></app-detail-content-aside>
            </ng-container>
          </div>
        </div>


      </div>

    </div>

  </div>
</div>

